import React from 'react'
import Layout from '../../Layout'
import FailedPayContainer from '../../../../Components/PayRequest/FailedPayContainer/FailedPayContainer'

const FailedPay = () => {
  return (
    <Layout><FailedPayContainer/></Layout>
  )
}

export default FailedPay